// @flow
export const COMMENT_VERSION = 2

/**
 * Helper method for generate a comment link based on commentable type / id.
 *
 * @param comment
 * @returns {string}
 */
export const commentLink = (comment: Comment): string => {
  if (comment.commentableType && comment.commentable) {
    // only link to the parent thread, it will load two pages of child comments
    const parentId = comment.parentId || comment.id

    if (comment.commentableType === 'discussion') {
      /* discussion comment link */
      return `/community/discussion/${comment.commentable.id}/${comment.commentable.seoUrl}/c/${parentId}#comments`
    } else if (comment.commentableType === 'plan' && comment.commentable) {
      /* plan comment link */
      return `/plans/${comment.commentable.seoUrl}/c/${parentId}#comments`
    } else if (comment.commentableType === 'article' && comment.commentable) {
      /* article comment link */
      return `/articles/${comment.commentable.seoUrl}/c/${parentId}#comments`
    } else if (comment.commentableType === 'workout' && comment.commentable) {
      /* video comment link */
      return `/videos/${comment.commentable.seoUrl}/c/${parentId}#comments`
    }
  }

  // catch all
  return ''
}

export const buildComment = (Comment: $Shape<Comment>): Comment => {
  let { children = [] } = Comment
  const {
    comment = '',
    imageUrl = '',
    imageDataString = '',
    id = 0,
    isLiked = false,
    isEdited = false,
    likeCount = 0,
    timeAgo = 'Now',
    user = {},
    imageError = false,
  } = Comment

  if (children.length) {
    children = children.map(buildComment)
  }

  return {
    children,
    comment,
    imageUrl,
    imageDataString,
    id,
    isLiked,
    isEdited,
    likeCount,
    timeAgo,
    user,
    userAdded: [],
    imageError,
  }
}
